<template>
  <el-button style="margin-right:10px" type="primary" @click="fpxfShow()" size="mini" plain>发票修复</el-button>
  <el-dialog
    v-model="dialogFormVisible"
    title="发票修复："
    width="30%"
    :before-close="handleClose"
  >

    <el-form :model="temp">
      <el-form-item label="发票类型代码" :label-width="formLabelWidth">
        <invoice-type v-model:code="temp.fplxdm"></invoice-type>
      </el-form-item>
      <el-form-item label="起始日期：" :label-width="formLabelWidth">
        <el-date-picker
          size="mini"
          value-format="YYYYMMDD"
          v-model="temp.qsrq"
          type="date"
          placeholder="起始日期"
          style="width:200px"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="终止日期：" :label-width="formLabelWidth">
        <el-date-picker
          size="mini"
          value-format="YYYYMMDD"
          v-model="temp.zzrq"
          type="date"
          placeholder="终止日期"
          style="width:200px"
        >
        </el-date-picker>
      </el-form-item>

    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button :loading="loading" size="mini" type="primary" @click="updateFpxf">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>

import { fpxf,updateInvoice } from "@/api/ea";
export default {
  props: {
    
  },
  data () {
    return {
      loading: false,
      formLabelWidth: "100px",
      dialogFormVisible: false,
      temp: {
        comId: this.$store.getters['user/comInfo'].id*1,
        fplxdm: '',
        qsrq: '',
        zzrq: '',
      },
    }
  },
  created () {
    
  },
  methods: {
    fpxfShow(){
      this.dialogFormVisible = true
    },
    updateFpxf(){
      if(this.temp.fplxdm == ""){
        this.$qzfMessage("请选择发票类型代码", 1)
        return
      }
      if(this.temp.qsrq == ""){
        this.$qzfMessage("请选择起始日期", 1)
        return
      }
      if(this.temp.zzrq == ""){
        this.$qzfMessage("请选择终止日期", 1)
        return
      }
      console.log(this.temp)
      this.loading = true
      //修复
      fpxf(this.temp).then(res=>{
        if(res.data.msg == "success"){
          // this.$qzfMessage("修复成功")
          // this.dialogFormVisible = false
        }
      })
      //更新之前的发票
      updateInvoice(this.temp).then(res=>{
         this.loading = false
        if(res.data.msg == "success"){
          this.$qzfMessage("修复成功")
          this.$emit("success")
          this.dialogFormVisible = false
        }
      })
    },
  }
}
</script>